import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = { py: 1, pt: 0, px: 0.5 };
